export default {
  state: {
    message: {
      status: false,
      body: null,
      type: 'success',
      timeout: 2000,
      vertical: true
    },
  },
  mutations: {
    setSnackbar: (state, data) => {
      state.message.status=true;
      state.message.body=data.body;
      state.message.type=data.type;
      state.message.vertical=false;
    },
    unsetSnackbar: (state) => {
      state.message.status=false;
      state.message.body='';
      state.message.type='';
      state.message.vertical=true;
    }
  },
  actions: {
    openSnackbar: ({ commit }, data) => {
      commit('setSnackbar', data);
    },
    closeSnackbar: ({ commit }) => {
      commit('unsetSnackbar');
    }
  }
}